export { default } from './DataTable'


// WEBPACK FOOTER //
// ./src/components/Table/DataTable/index.js